import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import "./AddFund.css";
import apiCall from "./../../API/API";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddFunds = () => {
  const [userName, setUserName] = useState("");
  const [amount, setAmount] = useState("");
  const [fundReason, setFundReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [existUserName, setExistUserName] = useState();
  const token = localStorage.getItem("authToken");
  const [is2faEnabled, setIs2faEnabled] = useState(false);
  const [otp, setOtp] = useState('');
  const [wallets, setWallets] = useState([]);
  const [selectedWallet, setSelectedWallet] = useState("");

  useEffect(() => {
    const check2FAStatus = async () => {
      // setLoading(true);
      try {
        const { data, error: apiError } = await apiCall('GET', '/check_2fa_status'); // Assuming an endpoint to check 2FA status
        if (apiError) {
          toast.error(apiError.message || 'Failed to fetch 2FA status.');
        } else if (data && typeof data.isEnabled === 'boolean') {
          console.log("status---------999", data);
          setIs2faEnabled(data.isEnabled);
        }
      } catch (err) {
        toast.error('An error occurred while fetching 2FA status.');
        console.error('2FA Status Fetch Error:', err);
      } finally {
        setLoading(false);
      }
    };
    check2FAStatus();
  }, []);

  useEffect(() => {
    const fetchWallets = async () => {
      try {
        const { data, error } = await apiCall("GET", "/get_wallets");
        if (data && data.wallets) {
          // Filter to only show fund and main wallets
          const filteredWallets = data.wallets.filter(w => 
            w.slug === "fund_wallet" || w.slug === "main_wallet" ||
            w.slug.includes("fund") || w.slug.includes("main")
          );
          setWallets(filteredWallets);
          // Set default wallet if available
          if (filteredWallets.length > 0) {
            const defaultWallet = filteredWallets.find(w => w.slug === "fund_wallet") || 
                                 filteredWallets.find(w => w.slug === "main_wallet") || 
                                 filteredWallets[0];
            setSelectedWallet(defaultWallet.slug);
          }
        } else if (error) {
          toast.error(error.message || "Failed to fetch wallets");
        }
      } catch (err) {
        toast.error("An error occurred while fetching wallets");
        console.error("Wallets Fetch Error:", err);
      }
    };
    fetchWallets();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // if (!userName || !amount) {
    //   toast.error("Please fill in all fields");
    //   return;
    // }

    const requestBody = {
      amount: amount,
      username: userName,
      wallet_name: selectedWallet,
      note: "Fund added by admin",
    };

    if (is2faEnabled) {
      requestBody.token = otp;
    }
    console.log("post data", requestBody);
    // return;

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token,
        },
      };
      const { data, error } = await apiCall(
        "post",
        "/add_fund",
        requestBody,
        config
      );

      if (data) {
        // toast.success(data?.message || "");
        setUserName("");
        setAmount("");
        setFundReason("");
        setOtp("");
      } else if (error) {
        // toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };
  const isUserExist = async () => {
    setLoading(true);

    if (!userName) {
      setExistUserName(". . .");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await apiCall("post", "/check_username", {
        username: userName,
      });
      if (data) {
        setExistUserName(data.name);
      } else if (error) {
        setExistUserName("User not exists");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  useEffect(() => {
    // Clear the timeout when the user is typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to call the API after the user stops typing
    setTypingTimeout(
      setTimeout(() => {
        isUserExist();
      }, 1000) // 500ms debounce delay
    );

    // Cleanup the timeout when the component is unmounted or when typing continues
    return () => clearTimeout(typingTimeout);
  }, [userName]);

  return (
    <React.Fragment>
      <Container className="mt-4">
        <section id="add-funds-section">
          <div className="d-flex justify-content-center">
            <h2>Add Funds</h2>
          </div>
          <section id="formContent">
            <div className="form">
              <Row>
                <Col lg={6} style={{ margin: "auto" }}>
                  <form onSubmit={handleSubmit}>
                    <div id="formFields">
                      <div className="mb-3">
                        <div className="d-flex">
                          <label htmlFor="userName">
                            User Name: {existUserName && <span style={{ marginLeft: "8px", color: "green" }}>{existUserName}</span>}
                          </label>
                          <label style={{ textAlign: "end" }}>
                            {/* Wallet: {name.find(w => w.slug === selectedWallet)?.name} */}
                           
                          </label>
                          {/* <label
                            style={{ textAlign: "end" }}
                            htmlFor="userName"
                          >
                            {loading && userName ? "Loading..." : existUserName}
                          </label> */}
                        </div>
                        <input
                          type="text"
                          id="userName"
                          className="form-control"
                          value={userName}
                          onChange={(e) => setUserName(e.target.value)}
                          placeholder="Enter your Username"
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="wallet">Select Wallet:</label>
                        <select
                          id="wallet"
                          className="form-control wallet-select"
                          value={selectedWallet}
                          onChange={(e) => setSelectedWallet(e.target.value)}
                          required
                        >
                          <option value="">--Select Wallet--</option>
                          {wallets.map((wallet, index) => (
                            <option key={index} value={wallet.slug}>
                              {wallet.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="mb-3">
                        <label htmlFor="amount">Amount:</label>
                        <input
                          type="number"
                          id="amount"
                          className="form-control"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="Enter Amount"
                          required
                        />
                      </div>
                       {is2faEnabled && (
                        <div className="mb-3">
                          <label htmlFor="otp">Enter OTP:</label>
                          <input
                            type="text"
                            id="otp"
                            className="form-control"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter OTP from your Authenticator App"
                            required
                          />
                        </div>
                      )}
                      {/* <div className="mb-3">
                        <label>Note:</label>
                        <input
                          type="text"
                          placeholder="Note for adding Fund"
                          value={fundReason}
                          onChange={(e) => setFundReason(e.target.value)}
                          className=""
                          required
                        />
                      </div> */}
                      <Button
                        type="submit"
                        variant="primary"
                        disabled={loading || !userName || !selectedWallet || existUserName === "User not exists" || existUserName === ". . ."}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </Button>
                      <Button
                        variant="secondary"
                        className="ms-2"
                        onClick={() => {
                          setUserName("");
                          setAmount("");
                          setFundReason("");
                          setOtp("");
                          if (wallets.length > 0) {
                            const defaultWallet = wallets.find(w => w.slug === "fund_wallet") || 
                                                  wallets.find(w => w.slug === "main_wallet") || 
                                                  wallets[0];
                            setSelectedWallet(defaultWallet.slug);
                          }
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </Col>
              </Row>
            </div>
          </section>
        </section>
        {/* <ToastContainer className="toast-container" /> */}
      </Container>
    </React.Fragment>
  );
};

export default AddFunds;
